const getTopicItem = (val) => val || '~'

/**
 * 获取 topic, 值为 ~ 代表全订阅
 * @param {*} param0
 * @param {*} type
 * @returns
 */
export const getTopic = ({ sportId, categoryId, tournamentId, eventId, productId, specifiers, marketId }, type = 1) => {
  sportId = sportId.replace(/\D/g, '')
  categoryId = categoryId.replace(/\D/g, '')

  const topicArr = [sportId, categoryId, tournamentId, eventId]

  if (type === 1) {
    // event status
    topicArr.push('status')
  } else {
    topicArr.push(getTopicItem(productId), getTopicItem(marketId), getTopicItem(specifiers))
    if (type === 2) {
      // market status
      topicArr.push('status')
    } else if (type === 3) {
      // market odds
      topicArr.push('odds')
    }
  }
  return topicArr.join('^')
}
